// extracted by mini-css-extract-plugin
export default {"front":"IconTimeOut_front__fXiNV","frontStrocked":"IconTimeOut_frontStrocked__ps3+-","back":"IconTimeOut_back__8RPB-","placeHolderShimmer":"IconTimeOut_placeHolderShimmer__E5dx0"};